const esquemaCampos = {
  codTicket: {valor: '', error: ''},
  asunto: {valor: '', error: ''},
  camposAdicionales: {valor: null, error: ''},
  prioridad: {valor: 0, error: ''},
  codTipoTicket: {valor: null, error: ''},
  codCliente: {valor: '', error: ''},
  nombre: {valor: '', error: ''},
  email: {valor: '', error: ''},
  descripcion: {valor: '', error: ''}
};

const esquemaValidacion = {
  codTicket: {
    requerido: true
  },
  asunto: {
    requerido: true,
    validador: {
      regla: valor => {
        return valor !== '';
      },
      error: 'El campo asunto no puede estar vacio.'
    }
  },
  camposAdicionales: {
    requerido: false
  },
  prioridad: {
    requerido: false,
    validador: {
      cast: valor => {
        return parseInt(valor);
      }
    }
  },
  codTipoTicket: {
    requerido: true,
    validador: {
      regla: valor => {
        return valor !== '';
      }
    }
  },
  codCliente: {
    requerido: true,
    validador: {
      regla: valor => {
        return valor !== '';
      }
    }
  },
  nombre: {
    requerido: false
  },
  email: {
    requerido: false,
    validador: {
      regla: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      error: 'El correo electronico no tiene un formato valido: [nombre]@[dominio].[etc]'
    }
  },
  descripcion: {
    requerido: false
  }
};

module.exports = {
  esquemaCampos,
  esquemaValidacion
  //esquemaQuery,
};
